import React from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
const QuestionIconButton = ({ isResolving, reason, size }) => {
  const theme = useTheme()
  return (
    <Tooltip title={reason || 'No reason provided'}>
      <IconButton
        size="small"
        disabled={isResolving}
        // onClick={onApprove}
        sx={{ height: size ?? 24, width: size ?? 24 }}
      >
        <HelpOutlineIcon sx={{ color: theme.palette.icon.warning, height: size ?? 24, width: size ?? 24 }} />
      </IconButton>
    </Tooltip>
  )
}

export default QuestionIconButton
